// Generated on 2025-12-23T21:59:24.083Z
// This file contains preloaded products top brands data from the API
// Do not edit manually - use 'npm run generate:products-top-brands-data' to regenerate

export const preloadedProductsTopBrands: any = [
  {
    "marca": "DORMAN",
    "cantidadProductosVendidos": "32302"
  },
  {
    "marca": "NAKAMOTO",
    "cantidadProductosVendidos": "21612"
  },
  {
    "marca": "GSP NORTH AMERICA",
    "cantidadProductosVendidos": "20739"
  },
  {
    "marca": "WAGNER QUICKSTOP",
    "cantidadProductosVendidos": "18929"
  },
  {
    "marca": "FEBEST",
    "cantidadProductosVendidos": "16047"
  },
  {
    "marca": "ONNURI",
    "cantidadProductosVendidos": "15270"
  },
  {
    "marca": "VALVOLINE",
    "cantidadProductosVendidos": "14228"
  },
  {
    "marca": "BANDO",
    "cantidadProductosVendidos": "14200"
  },
  {
    "marca": "DENSO",
    "cantidadProductosVendidos": "13154"
  },
  {
    "marca": "DNJ",
    "cantidadProductosVendidos": "12091"
  },
  {
    "marca": "MAHLE ORIGINAL",
    "cantidadProductosVendidos": "11553"
  },
  {
    "marca": "BECK/ARNLEY",
    "cantidadProductosVendidos": "10081"
  },
  {
    "marca": "ECOGARD",
    "cantidadProductosVendidos": "8746"
  },
  {
    "marca": "FAG",
    "cantidadProductosVendidos": "7913"
  },
  {
    "marca": "BLUE PRINT",
    "cantidadProductosVendidos": "7759"
  },
  {
    "marca": "555",
    "cantidadProductosVendidos": "7553"
  },
  {
    "marca": "DAYCO",
    "cantidadProductosVendidos": "7016"
  },
  {
    "marca": "PT",
    "cantidadProductosVendidos": "6943"
  },
  {
    "marca": "MOOG",
    "cantidadProductosVendidos": "6409"
  },
  {
    "marca": "PRESTONE",
    "cantidadProductosVendidos": "6286"
  },
  {
    "marca": "MOTORAD",
    "cantidadProductosVendidos": "6222"
  },
  {
    "marca": "DORMAN PREMIUM",
    "cantidadProductosVendidos": "6034"
  },
  {
    "marca": "MOOG EU",
    "cantidadProductosVendidos": "6030"
  },
  {
    "marca": "TENACITY",
    "cantidadProductosVendidos": "5759"
  },
  {
    "marca": "HS",
    "cantidadProductosVendidos": "5541"
  },
  {
    "marca": "STANDARD/INTERMOTOR",
    "cantidadProductosVendidos": "5477"
  },
  {
    "marca": "WALKER",
    "cantidadProductosVendidos": "5159"
  },
  {
    "marca": "NATIONAL",
    "cantidadProductosVendidos": "5070"
  },
  {
    "marca": "WAGNER",
    "cantidadProductosVendidos": "4806"
  },
  {
    "marca": "EAGLE BHP",
    "cantidadProductosVendidos": "4481"
  }
];

export default preloadedProductsTopBrands;
